module.exports = __webpack_public_path__ + "static/media/16.2bbc0544.mp3";